import React from 'react'
import { string } from 'prop-types'
import { Grid, Link, Image, Paragraph } from '@cobalt/cobalt-react-components'
import { AUTHENTICATOR_APP_DOWNLOAD } from '../../../constants/ui.labels'
import {
  DOWNLOAD_AUTHENTICATOR_APP_APPLE_STORE,
  DOWNLOAD_AUTHENTICATOR_APP_GOOGLE_PLAY
} from '../../../constants/links'
import { GOOGLE_PLAY_BADGE, APPLE_STORE_BADGE } from '../../../constants/images'

const DownloadAppLink = ({ url, img }) => (
  <Link target="_blank" href={url}>
    <Image src={img} width={130} alt="" />
  </Link>
)

DownloadAppLink.propTypes = {
  url: string.isRequired,
  img: string.isRequired
}

export const AuthenticatorAppDownload = () => (
  <Grid>
    <Grid.Group verticalGutters={Grid.Group.HALF_VERTICAL_GUTTERS}>
      <Grid.Column alignCenter all="100">
        <Paragraph microcopy>{AUTHENTICATOR_APP_DOWNLOAD}</Paragraph>
      </Grid.Column>
    </Grid.Group>
    <Grid.Group>
      <Grid.Column alignCenter all="50" medium="50" small="100" tiny="100">
        <DownloadAppLink
          url={DOWNLOAD_AUTHENTICATOR_APP_APPLE_STORE}
          img={APPLE_STORE_BADGE}
        />
      </Grid.Column>
      <Grid.Column alignCenter all="50" medium="50" small="100" tiny="100">
        <DownloadAppLink
          url={DOWNLOAD_AUTHENTICATOR_APP_GOOGLE_PLAY}
          img={GOOGLE_PLAY_BADGE}
        />
      </Grid.Column>
    </Grid.Group>
  </Grid>
)
